/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";

import { debounce } from "lodash";
import ReactTable from "react-table";
import { IoStarOutline, IoStar } from "react-icons/io5";

import ProjectService from "../../services/projectService";
import ProjectProgressBar from "./ProjectProgressBar";
import Loading from "../common/Loading";
import TableActions from "../common/TableActions";
import ResponsiveDataComponent from "../common/ResponsiveDataComponent";
import Badge from "../common/Badge";

import { formatDate } from "../../helpers/date";

class ProjectList extends Component {
  fetchData = debounce(async (state) => {
    const { pageSize, page, sorted, filtered } = state;

    const { projects, pages } = await ProjectService.loadProjects({
      pageSize,
      page,
      sorted,
      filtered,
      auth: this.props.auth.user._id
    });

    this.setState({ projects, pages, loading: false });
  }, 250);

  constructor(props) {
    super(props);
    this.state = { projects: [], pages: 1, loading: false };
  }

  componentDidMount = () => {
    this.setState({ loading: true });
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.projects !== this.props.projects) {
      this.setState({ projects: nextProps.projects, loading: false });
    }
  };

  render() {
    const {
      filtered,
      sorted,
      isMobile,
      minimal,
      auth,
      pageSize,
      serverSide,
      clientSide,
      onClickView,
      onClickFavorite,
      defaultPageSize,
      onPageSizeChange,
      onClickFullView
    } = this.props;
    const { projects, pages, loading } = this.state;
    const { favorites } = auth.user;

    const columns = !isMobile
      ? [
          {
            Header: "Favorites",
            headerClassName: "flex -center-h",
            accessor: (row) => {
              const isFavorite = !!(
                favorites && favorites.find((e) => e === row._id)
              );
              return isFavorite;
            },
            id: "favorited",
            maxWidth: 80,
            Cell: (row) => {
              const isFavorite = row.value;
              const iconStyle = isFavorite ? "#FFD275" : "#848487";

              return (
                <span className="text-center" style={{ display: "block" }}>
                  {isFavorite ? (
                    <IoStar
                      onClick={() => onClickFavorite(row.original._id)}
                      style={{ color: iconStyle, textAlign: "center" }}
                    />
                  ) : (
                    <IoStarOutline
                      onClick={() => onClickFavorite(row.original._id)}
                      style={{ color: iconStyle, textAlign: "center" }}
                    />
                  )}
                </span>
              );
            }
          },
          {
            Header: "Status",
            accessor: "project_status",
            minWidth: 110,
            sortable: false,
            Cell: ({ value }) => (
              <Badge color={value.color}>{value.label || "--"}</Badge>
            )
          },
          { Header: "Project Name", accessor: "name" },
          { Header: "Customer", accessor: "customer.name" },
          { Header: "Call Type", accessor: "call_type.label" },
          { Header: "Project Manager", accessor: "project_manager.full_name" },
          {
            Header: "Start Date",
            accessor: "start_date",
            Cell: (row) =>
              row.value ? formatDate(row.value, "MM/dd/yyyy") : "--"
          },
          {
            Header: "End Date",
            accessor: "end_date",
            Cell: (row) =>
              row.value ? formatDate(row.value, "MM/dd/yyyy") : "--"
          },
          {
            id: "budgetConsumed",
            Header: "Hours Consumed",
            headerClassName: "flex -center-h",
            sortable: false,
            Cell: (row) => (
              <ProjectProgressBar
                auth={auth}
                project={row.original}
                data={
                  row.original?.consumedBudget
                    ? row.original.consumedBudget[0]
                    : {}
                }
                type="circular"
              />
            )
          }
        ]
      : [
          {
            Header: "Favorites",
            accessor: (row) => {
              const isFavorite = !!(
                favorites && favorites.find((e) => e === row._id)
              );
              return isFavorite;
            },
            id: "favorited",
            maxWidth: 100,
            Cell: (row) => {
              const isFavorite = favorites
                ? favorites.find((e) => e === row.original._id)
                : false;
              const iconStyle = isFavorite ? "#FFD275" : "#848487";

              return (
                <span className="text-center" style={{ display: "block" }}>
                  {isFavorite ? (
                    <IoStar
                      onClick={() => onClickFavorite(row.original._id)}
                      style={{ color: iconStyle, textAlign: "center" }}
                    />
                  ) : (
                    <IoStarOutline
                      onClick={() => onClickFavorite(row.original._id)}
                      style={{ color: iconStyle, textAlign: "center" }}
                    />
                  )}
                </span>
              );
            }
          },
          {
            Header: "Project Name",
            accessor: "name"
          }
        ];

    columns.push({
      accessor: "_id",
      maxWidth: 80,
      sortable: false,
      Cell: (row) =>
        onClickFullView ? (
          <TableActions
            onClickView={() => onClickView(row.value)}
            onClickFullView={() => onClickFullView(row.value)}
            viewText="Quick View"
          />
        ) : (
          <TableActions onClickView={() => onClickView(row.value)} />
        )
    });

    const props = {
      getTdProps: (state, rowInfo, column) => {
        if (!column.expander && rowInfo?.original?._id) {
          return {
            onClick: () => {
              if (column.id !== "_id" && column.id !== "favorited") {
                onClickView(rowInfo.original._id);
              }
            }
          };
        }
        return {};
      }
    };

    const serverSideProps = {
      manual: true,
      pages,
      onFetchData: this.fetchData,
      filtered
    };

    return (
      <ReactTable
        {...props}
        {...(serverSide && serverSideProps)}
        {...(clientSide && {
          defaultSorted: sorted || [] // [{ id: "favorited", desc: true }]
        })}
        {...(pageSize && {
          pageSize: projects.length < pageSize ? projects.length : pageSize
        })}
        {...(minimal && {
          pageSize: minimal && projects.length ? projects.length + 1 : 10
        })}
        ref={(r) => (this.table = r)}
        className="-highlight"
        data={projects}
        columns={columns}
        noDataText="No projects found"
        showPageSizeOptions={!isMobile}
        showPagination={!(minimal || projects.length < pageSize)}
        defaultPageSize={defaultPageSize}
        LoadingComponent={() => <Loading active={loading} />}
        onPageSizeChange={onPageSizeChange}
        SubComponent={
          isMobile
            ? ({ original }) => (
                <ResponsiveDataComponent
                  data={[
                    { key: "Number", label: original.project_number },
                    { key: "Name", label: original.name },
                    { key: "Customer", label: original.customer.name },
                    { key: "Call Type", label: original.call_type.label },
                    {
                      key: "Start Date",
                      label: formatDate(original.start_date, "MM/dd/yyyy")
                    }
                  ]}
                />
              )
            : false
        }
      />
    );
  }
}

ProjectList.propTypes = {
  filtered: PropTypes.object,
  sorted: PropTypes.object,
  isMobile: PropTypes.bool,
  minimal: PropTypes.bool,
  auth: PropTypes.object,
  pageSize: PropTypes.number,
  serverSide: PropTypes.bool,
  clientSide: PropTypes.bool,
  onClickView: PropTypes.func,
  onClickDelete: PropTypes.func,
  defaultPageSize: PropTypes.number,
  projects: PropTypes.array,
  onClickFavorite: PropTypes.func,
  setClick: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onClickFullView: PropTypes.func
};

ProjectList.defaultProps = {
  defaultPageSize: 10
};
export default ProjectList;
